import React from "react";
import PropTypes from "prop-types";
import { Badge } from "@react-spectrum/badge";
import BadgeCss from "./Badge.css";

const VerbBadge = ({ children, variant }) => (
  <Badge variant={variant} UNSAFE_className={BadgeCss.badge}>
    {children}
  </Badge>
);

VerbBadge.propTypes = {
  children: PropTypes.string.isRequired,
  variant: PropTypes.string
};

VerbBadge.defaultProps = {
  variant: "info"
};

export default VerbBadge;
